import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import Language from '../../../../customComponents/Language'
import Location from '../../../../customComponents/Location'
import SearchPage from '../../../../customComponents/SearchPage'
import { removeUserFromLocalStorage } from '../../../../utils/utils'
import { fetchCartDetails } from '../../../../utils/cartSlice'
import { routePaths } from '../../../../routes/routeConstants'
import { logoutUser } from '../../../../utils/commonSlice'
import MobileCategories from '../../MobilePages/MobileHomePage/MobileCategories'
import MobileBanners from '../../MobilePages/MobileHomePage/MobileBanners'
import { searchProducts } from '../../../Desktop/Pages/ProductListing/Categories/Apis/productListingSlice'
import { useTranslation } from 'react-i18next'

const MobileNavbar = ({ user }) => {
	const { productQuantity } = useSelector((state) => state.cart)
	const { t } = useTranslation()

	const navigate = useNavigate() // Initialize navigate
	const dispatch = useDispatch()
	const { total } = useSelector((state) => state.productsListing.searchProducts)

	const handleLogout = async (e) => {
		e.preventDefault()
		const result = await dispatch(logoutUser())
		if (result?.payload?.data?.status === 1) {
			removeUserFromLocalStorage()
			await dispatch({ type: 'logout' })
			navigate(routePaths.signIn)
		}
	}

	useEffect(() => {
		const body = {
			search: '',
		}
		dispatch(searchProducts(body))
		if (user) {
			dispatch(fetchCartDetails())
		}
	}, [])

	const productsSearchChange = (e) => {
		const body = {
			search: e.target.value,
		}
		dispatch(searchProducts(body))
	}

	return (
		<div className='display-full display-mob '>
			<div className={`card shadow-none background-image-yellow ${total === 0 && 'min-height-300'} header-card-radius`}>
				<div className='d-flex px-2 justify-content-between align-items-center p-2'>
					<div>
						<a data-bs-toggle='offcanvas' data-bs-target='#offcanvasTopMaxLocation' aria-controls='offcanvasTop'>
							<div className='justify-content-lg-start align-items-center'>
								{user ? (
									<div className='lh-1'>
										<div className=' mt-0'>
											<b className='text-black fw-bolder fs-5'>{user?.data?.fullName} </b>
										</div>
										<div className='mt-1 text-nowrap'>
											<b className=' text-black fw-normal text-xs'>
												{user?.data?.city}
												&nbsp;{user?.data?.zipCode}
												<span className='dropdown-toggle ms-1'></span>
											</b>
										</div>
									</div>
								) : (
									<div className='ms-2 text-xs text-black lh-1'>
										<div>
											<b className='text-black fw-bolder fs-4'>{t('hello')}</b>
										</div>
										<div>
											<b className='text-black fw-bolder fs-4'>sign in</b>
										</div>
									</div>
								)}
							</div>
						</a>
					</div>
					<div>
						<div className='d-flex justify-content-center align-items-center gap-2'>
							<div>
								<Link to='/FooterTestimonials'>
									<div class='icon icon-md-2  bg-white border shadow text-center rounded-circle p-1'>
										<i class='bi bi-star-fill fs-6 text-danger opacity-9'></i>
									</div>
								</Link>
							</div>
							<div className='position-relative'>
								<Link to={user ? '/Cart' : '/UserSignin'}>
									<div class='icon icon-md-2  bg-white border shadow text-center rounded-circle p-1'>
										<i class='bi bi-handbag-fill fs-6 text-primary opacity-9'></i>
										<span
											className='mt-1 position-absolute translate-middle badge-sm small text-dark'
											style={{ top: '8px', left: '32px' }}
										>
											{productQuantity ?? 0}
										</span>
									</div>
								</Link>
							</div>
							<div className='position-relative'>
								<div class='icon icon-md-2  bg-white border shadow text-center rounded-circle p-1'>
									<img src='../../assets/img/svg/bell.svg' width='18' height='18' className='opacity-6' alt='' />

									{/* <span className='position-absolute top-0 start-100 translate-middle badge-sm text-black bg-light small'>0</span> */}
								</div>
							</div>
							{user && (
								<div>
									<div className='icon icon-md-2  bg-white border shadow text-center rounded-circle p-1' onClick={handleLogout}>
										<i className='material-icons-round text-primary fs-3'>power_settings_new</i>
									</div>
								</div>
							)}
						</div>
					</div>
				</div>
				<div className='p-2 mt-n2'>
					<div className='d-flex justify-content-between align-items-center gap-2'>
						<div className=' w-100'>
							<div className='input-group input-group-outline align-items-center'>
								<input
									type='text'
									className='form-control bg-white'
									placeholder='Search for Products, Brands and More'
									// data-bs-toggle='offcanvas'
									// data-bs-target='#offcanvasRightSearch'
									// aria-controls='offcanvasRight'
									onChange={productsSearchChange}
								/>
								<span className='input-group-text end-2 p-2 opacity-10 d-block'>
									<img src='../../assets/img/svg/search.svg' height='17' alt='' />
								</span>
							</div>
						</div>
						<div>
							<span className='end-1 opacity-10'>
								<i class='bi bi-qr-code-scan fs-4 opacity-10 me-0 text-black'></i>
							</span>
						</div>
					</div>
				</div>
				{total === 0 && (
					<>
						<div className='border-bottom-light'>
							<MobileCategories />
						</div>
						<div className=' mt-2 mb-2'>
							<MobileBanners />
						</div>
					</>
				)}
			</div>
			<div
				class='offcanvas offcanvas-bottom h-75 border-radius-top-end-2xl border-radius-top-start-2xl'
				tabindex='-1'
				id='offcanvasBottomLanguage'
				aria-labelledby='offcanvasBottomLabel'
			>
				<div class='offcanvas-header border-bottom shadow'>
					<h5 class='offcanvas-title' id='offcanvasBottomLabel'>
						Select Language
					</h5>
					<img src='../../assets/img/svg/close.svg' data-bs-dismiss='offcanvas' aria-label='Close' alt='' />
				</div>
				<div class='offcanvas-body small mb-3'>
					<Language />
				</div>
				<div class='offcanvas-footer text-center mb-2'>
					<button type='button' class='btn btn-dark btn-lg w-95 m-1'>
						Select
					</button>
				</div>
			</div>
			<div class='offcanvas offcanvas-top h-100' tabindex='-1' id='offcanvasTopMaxLocation' aria-labelledby='offcanvasTopLabel'>
				<div class=' bg-gray-100 p-2'>
					<div className='d-flex align-items-center'>
						<div>
							<a href='#'>
								<i
									class='bi bi-arrow-left-short me-2 fa-2x icon-color'
									aria-hidden='true'
									data-bs-dismiss='offcanvas'
									aria-label='Close'
								></i>
							</a>
						</div>
						<div>
							<h6 class='offcanvas-title' id='offcanvasBottomLabel'>
								Enter your address
							</h6>
						</div>
					</div>
				</div>
				<div class='offcanvas-body'>
					<Location />
				</div>
			</div>
			<div class='offcanvas offcanvas-end w-100' tabindex='-1' id='offcanvasRightSearch' aria-labelledby='offcanvasRightLabel'>
				<div class=' container-fluid p-1 shadow'>
					<div className=' align-items-center'>
						<div class='input-group input-group-outline align-items-center'>
							<a href=''>
								<i
									class='bi bi-arrow-left-short me-2 fa-2x icon-color'
									aria-hidden='true'
									data-bs-dismiss='offcanvas'
									aria-label='Close'
								></i>
							</a>
							<input type='text' class='form-control' placeholder='Search for Products, Brands and More' />
							<span class='input-group-text end-3 opacity-5 position-absolute'>
								<img src='../../assets/img/svg/search.svg' height='20' alt='' />
							</span>
						</div>
					</div>
				</div>
				<div class='offcanvas-body'>
					<SearchPage />
				</div>
			</div>
		</div>
	)
}

export default MobileNavbar
